import { useEffect, useState } from "react";
import styles from "../index.less";
import icon_right from "../../../asset/img/login/icon_right.png";
import evaluate5 from "../../../asset/img/login/evaluate5.png";
import Blank from "../components/blank";
import { recommendContentDiag } from "api/doctor-list";
import Pagination from "../components/pagination";
import { departNav, hospitalNav } from "utils/hospital";
import { isJsonObj } from "utils";
import { recommendContentQaGW } from "api/hospital";


/**
 * 
 * @param showAll 控制是否有分页，是否默认展示全部 
 * @returns 
 */

const ConsultationList = ({ tabIndex, initData, pageId, showAll, current, name, departId }: any) => {
  const moreUrl = departId ? departNav(`${pageId}-${departId}`)[tabIndex]?.url : hospitalNav(pageId)[tabIndex]?.url;
  const [consultationIndex, setConsultationIndex] = useState<number>(3);
  const [data, setContentDiagData] = useState<any>();
  const [nextPage, setNextPage] = useState<boolean>(false);
  const [pageNo, setPageNo] = useState<number>(current);
  const textParagraphContent = (data: any) => {
    return (
      data &&
      data?.length > 0 &&
      data
        ?.map((val: any) => {
          if (
            val?.body?.type == "text" &&
            val?.from?.app == "jd.doctor" &&
            val?.body?.content
          ) {
            return val?.body?.content;
          }
        })
        .filter((itme: any) => {
          return itme && itme.trim();
        })
        .join("")
    );
  };
  useEffect(() => {
    getContentDiag(pageId);
  }, [])
  // 问诊记录
  const getContentDiag = (hospitalId: any) => {
    let allParam = {};
    if(showAll){
      allParam = {
        contentDiag: {
          displayFlag: 1
        },
        contentTypes: [18],
        contentStatus: [1],
      }
    }
    
    // 医患交流推荐
    (showAll ? recommendContentDiag({
      osName: "content",
      version: 13,
      methodName: showAll ? "queryContents450" : "recommendContentQa435",
      floorId: 5092,
      appId: "c59cb704c24245a58768efa1ca1b4940",
      contentDoctorBizParams: [{
        hospitalId,
        secondDepartId: departId,
      }],
      sortOrderParams: [{
        field: "contentDiags.diagnoseEndTime",
        order: "desc"
      }],
      ...allParam,
      pageNo,
      pageSize: 10,
      tenantId: 287
    }) : recommendContentQaGW({
      contentDoctorBizParams: [{
        hospitalId,
        secondDepartId: departId,
      }],
      sortOrderParams: [{
        field: "contentDiags.diagnoseEndTime",
        order: "desc"
      }],
      ...allParam,
      pageNo,
      pageSize: 10,
      tenantId: 287
    })).then((res: any) => {
      if (!showAll) {
        setContentDiagData(res || []);
        return;
      }
      setContentDiagData(res.data || []);
      setNextPage(res.pageNo < res.totalPage || false);
      setPageNo(res.pageNo || 1);
    }).catch(() => {
      setContentDiagData([])
    })
  }
  if(!data?.length){
    return null;
  }
  return initData?.hospitalName  ? (
    <Blank className={styles.consultationList} title={`${name || ''}问诊记录`} moreUrl={moreUrl}> 
      {data && data?.length > 0 ? (
        <>
          <ul>
            {data.map((itme: any, index: any) => {
              return (
                <li
                  key={itme.diagId}
                  onClick={() => {
                    window.open(
                      window.location.origin +
                      "/qa" +
                      "/" +
                      itme?.contentDiags[0]?.diagId
                    );
                  }}
                  className={!showAll && index >= consultationIndex ? styles.displayNone : ''}
                >
                  <div className={styles.consultationNo}>
                    {itme?.contentParagraphs.map(
                      (v: any, idnex1: any) => {
                        try {
                          let text: any = isJsonObj(v?.paragraphContent) ? textParagraphContent(
                            JSON.parse(v?.paragraphContent || {}) || {}
                          ) : v?.paragraphContent;
                          return (
                            <div key={v.paragraphCode}>
                              {(itme?.contentName + text)?.substring(0, 100)}
                            </div>
                          );
                        } catch (error) {
                          console.log(v?.paragraphContent, index);
                          console.log(error, 'error')
                        }
                      }
                    )}
                  </div>
                  <div className={styles.consultationListTop}>
                    <div
                      className={styles.consultationListTopText}
                      data-a-href={"/qa/" + itme?.contentDiags[0]?.diagId}
                    >
                      {itme?.contentName}
                    </div>
                    <div className={styles.consultationListTopInfo}>
                      <span>
                        点击查看
                      </span>
                      <img src={icon_right} alt="" />
                    </div>
                  </div>
                  <div className={styles.consultationListBon}>
                    <div className={styles.consultationListBonLeft}>
                      <div
                        className={styles.consultationListBonLeftText1}
                      >
                        <h3>总交流次数</h3>
                        <h5>
                          {itme?.contentDiags[0]?.doctorExchangeCount +
                            itme?.contentDiags[0]?.patientExchangeCount ||
                            0}
                        </h5>
                      </div>
                      <div
                        className={styles.consultationListBonLeftLine}
                      />
                      <div
                        className={styles.consultationListBonLeftText2}
                      >
                        <h3>总回复次数</h3>
                        <h5>
                          {itme?.contentDiags[0]?.doctorExchangeCount ||
                            0}
                        </h5>
                      </div>
                    </div>
                    <div className={styles.consultationListBonInfo}>
                      <span>患者：</span>
                      <span className={styles.h4}>
                        {itme?.contentDiags[0]?.patientSex == 1
                          ? "男 "
                          : "女 "}
                        {itme?.contentDiags[0]?.patientAge || 0}
                      </span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
          {/* 展开更多 */}
          { !showAll &&
            <div className={styles.evaluateListMore}>
              <p
                onClick={() => {
                  if (consultationIndex <= 3) {
                    setConsultationIndex(10);
                  }
                }}
              >
                {initData &&
                  consultationIndex <= 3 ? (
                  <>
                    <span>展开更多</span>
                    <img src={evaluate5} alt="" />
                  </>
                ) : null}
              </p>
            </div>
          }
          { showAll && 
            <Pagination
              pageId={pageId}
              current={current}
              nextPage={nextPage}
              nextUrl={`/hospital${departId ? `/department` : ''}/${pageId}${departId ? `-${departId}` : ''}-${pageNo+1}/${departId ? 'wenzhenlist' : 'qalist'}`}
              preUrl={`/hospital${departId ? `/department` : ''}/${pageId}${departId ? `-${departId}` : ''}-${pageNo-1}/${departId ? 'wenzhenlist' : 'qalist'}`}    
            />
          }
        </>
      ) : (
        data?.length == 0 ? <div className={styles.noData}>暂无问诊记录</div> : <div className={styles.noData}>加载中...</div>
      )}
    </Blank>
  ) : <></>;
}
export default ConsultationList;